module.exports = __webpack_public_path__ + "static/media/stofferingen-14.9a250a49.jpg";